import type { ReactNode } from "react";

function renderInline(text: string): ReactNode[] {
  const parts: ReactNode[] = [];
  const regex = /\*\*(.+?)\*\*/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(
      <strong key={`b-${key++}`} className="font-semibold">
        {match[1]}
      </strong>,
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : [text];
}

export function FormatCopilotText({
  text,
  streaming = false,
}: {
  text: string;
  streaming?: boolean;
}) {
  if (!text) return null;

  if (streaming) {
    return <span className="whitespace-pre-wrap">{text}</span>;
  }

  const blocks = text.split(/\n{2,}/);

  return (
    <div className="space-y-2">
      {blocks.map((block, blockIdx) => {
        const lines = block.split("\n");
        const listLines = lines.filter((line) => /^[-*•]\s+/.test(line.trim()));
        const isList = listLines.length > 0 && listLines.length === lines.length;

        if (isList) {
          return (
            <ul key={blockIdx} className="list-disc space-y-1 pl-4">
              {lines.map((line, lineIdx) => (
                <li key={lineIdx} className="leading-relaxed">
                  {renderInline(line.replace(/^[-*•]\s+/, ""))}
                </li>
              ))}
            </ul>
          );
        }

        return (
          <p key={blockIdx} className="whitespace-pre-wrap leading-relaxed">
            {lines.map((line, lineIdx) => (
              <span key={lineIdx}>
                {lineIdx > 0 ? <br /> : null}
                {renderInline(line)}
              </span>
            ))}
          </p>
        );
      })}
    </div>
  );
}
